__webpack_require__.p = "/static/tal-client/";